import { Effect } from "../Materials/effect";
import "./ShadersInclude/helperFunctions";
var name = 'layerPixelShader';
var shader = "\nvarying vec2 vUV;\nuniform sampler2D textureSampler;\n\nuniform vec4 color;\n\n#include<helperFunctions>\nvoid main(void) {\nvec4 baseColor=texture2D(textureSampler,vUV);\n#ifdef LINEAR\nbaseColor.rgb=toGammaSpace(baseColor.rgb);\n#endif\n#ifdef ALPHATEST\nif (baseColor.a<0.4)\ndiscard;\n#endif\ngl_FragColor=baseColor*color;\n}";
Effect.ShadersStore[name] = shader;
/** @hidden */
export var layerPixelShader = { name: name, shader: shader };
//# sourceMappingURL=layer.fragment.js.map